import * as React from 'react';

import Collaborations16 from './Collaborations16';

export const collaborations16 = () => <Collaborations16 />;

export default {
    title: 'Icon/Line/Collaborations16',
    component: Collaborations16,
    parameters: {
        notes: "`import Collaborations16 from 'box-ui-elements/es/icon/line/Collaborations16';`",
    },
};
